import { UseMutationOptions } from "@tanstack/react-query";
import { ClientError } from "graphql-request";

import { graphql } from "lib/generated/app-service-gql";
import {
  StartBidOrchestratorMutation,
  StartBidOrchestratorMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../../useGraphQlClient";

const START_BID_ORCHESTRATOR = graphql(`
  mutation StartBidOrchestrator($input: StartBidOrchestratorRequest!) {
    startBidOrchestrator(StartBidOrchestratorRequest: $input) {
      success
      runId
    }
  }
`);

export function useStartBidOrchestrator(
  options?: UseMutationOptions<
    StartBidOrchestratorMutation,
    ClientError,
    StartBidOrchestratorMutationVariables,
    unknown
  >,
) {
  const { data, ...rest } = useGraphQlMutation(START_BID_ORCHESTRATOR, options);
  return { data: data?.startBidOrchestrator, ...rest };
}
